import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { GeneralSettings } from './settings-general.component';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';

export function provideSettingsElementGeneralSettings(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'general',
        name: 'General Settings',
        icon: 'pi pi-cog',
        component: GeneralSettings,
        order: 1,
        translateName: 'SETTINGS_GENERAL.TITLE',
        resource_key: 'tenant',
        required_action: 'read',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'workspace',
          name: 'Workspace',
          order: 1,
          translateName: 'SETTINGS.CATEGORIES.WORKSPACE',
        },
      },
      multi: true,
    },
  ]);
}
